import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage.jsx";
import AdminTrackingPage from "./pages/AdminTrackingPage.jsx";
import AuthPage from "./pages/AuthPage.jsx";
import TrackingPage from "./pages/TrackingPage.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/tracking" element={<TrackingPage />} />{" "}
        {/* guest route */}
        <Route path="/tracking/admin-panel" element={<AdminTrackingPage />} />
        <Route path="/tracking/admin-panel/auth" element={<AuthPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
